import { Injectable } from '@angular/core';
import { PrivacyStateService } from './privacy-state.service';

@Injectable()
export class ProdPrivacyStateService extends PrivacyStateService {}
